import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Cart: FC<Props> = ({ width = 28, height = 22, className, color = "#2A1645" }) => {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			width={width}
			height={height}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.5699 8.5125C21.4995 8.43018 21.4121 8.36408 21.3137 8.31877C21.2153 8.27345 21.1083 8.24999 20.9999 8.25H16.4999V5.25C16.4999 4.65326 16.2629 4.08097 15.8409 3.65901C15.419 3.23705 14.8467 3 14.2499 3H9.74995C9.15321 3 8.58091 3.23705 8.15896 3.65901C7.737 4.08097 7.49995 4.65326 7.49995 5.25V8.25H2.99995C2.89123 8.24877 2.78355 8.27119 2.68436 8.31571C2.58517 8.36022 2.49684 8.42578 2.4255 8.50782C2.35416 8.58986 2.30151 8.68643 2.2712 8.79084C2.24088 8.89526 2.23363 9.00501 2.24995 9.1125L3.65995 18.225C3.71419 18.5827 3.89587 18.9087 4.17152 19.143C4.44717 19.3773 4.7982 19.5041 5.15995 19.5H18.8549C19.2167 19.5041 19.5677 19.3773 19.8434 19.143C20.119 18.9087 20.3007 18.5827 20.3549 18.225L21.7499 9.1125C21.765 9.00543 21.7567 8.89637 21.7256 8.79281C21.6945 8.68925 21.6414 8.59363 21.5699 8.5125ZM8.99995 5.25C8.99995 5.05109 9.07897 4.86032 9.21962 4.71967C9.36027 4.57902 9.55104 4.5 9.74995 4.5H14.2499C14.4489 4.5 14.6396 4.57902 14.7803 4.71967C14.9209 4.86032 14.9999 5.05109 14.9999 5.25V8.25H8.99995V5.25ZM18.8549 18H5.14495L3.87745 9.75H20.1224L18.8549 18Z"
				fill={color}
			/>
		</svg>
  	);
};

export default Cart;
